
import React from 'react';
import { useContentImages } from '@/hooks/useContentImages';

const AboutHero = () => {
  const { images: aboutImages } = useContentImages('about');
  const heroImage = aboutImages[0];

  return (
    <section className="relative flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-slate-800/70 to-blue-900/80 z-10"></div>
        <img
          src={heroImage?.image_url}
          alt={heroImage?.alt_text || ""}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 z-20 opacity-10">
        <div className="absolute top-20 left-20 w-96 h-96 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-purple-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container-custom relative z-30 text-center pt-24 pb-24">
        <div className="max-w-4xl mx-auto animate-on-scroll">
           <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white"> About GoalTec</h1>
            <p className="text-xl text-slate-200">
              We are passionate technology enthusiasts dedicated to delivering innovative IT solutions 
            that drive business growth and digital transformation.
            </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-30">
        <div className="w-6 h-10 border-2 border-white/60 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
